import React, { Fragment, useEffect, useState } from "react";
import CustomSearchBox from "./CustomSearchBox";
// import Hit from "./Hit";
import CustomHits from "./Hits";
import DropDown from "./DropDown";

import {
    // Hits,
    RefinementList,
    Pagination,
    Configure,
    CurrentRefinements,
} from "react-instantsearch-dom";

const MainContent = (props) => {

    return (
        <Fragment>
            <div className="px-4 pt-3 pb-4 sticky-top bg-light d-flex flex-column">
                <CustomSearchBox {...props} />

                <div className="il-search-options-container mb-3 d-none d-md-block order-first">
                    <div className="d-none">
                        <DropDown label="mediaTags">
                            <RefinementList
                                attribute="mediaTags"
                                limit={10}
                                searchable
                            />
                        </DropDown>
                    </div>
                    <DropDown label="Categories">
                        <RefinementList
                            attribute="categories"
                            limit={500}
                            searchable
                        />
                    </DropDown>
                    <DropDown label="Permits">
                        <RefinementList
                            attribute="permit"
                            limit={500}
                            searchable
                        />
                    </DropDown>
                    <DropDown label="City">
                        <RefinementList
                            attribute="city"
                            limit={500}
                            searchable
                        />
                    </DropDown>
                    <DropDown label="County">
                        <RefinementList
                            attribute="county"
                            limit={500}
                            searchable
                        />
                    </DropDown>
                    <DropDown label="Access">
                        <RefinementList
                            attribute="access"
                            limit={500}
                            searchable
                        />
                    </DropDown>
                    <DropDown label="Floors">
                        <RefinementList
                            attribute="floors"
                            limit={500}
                            searchable
                        />
                    </DropDown>
                    <DropDown label="Patio Balconies">
                        <RefinementList
                            attribute="patioBalconies"
                            limit={500}
                            searchable
                        />
                    </DropDown>
                    <DropDown label="Pool">
                        <RefinementList
                            attribute="pools"
                            limit={500}
                            searchable
                        />
                    </DropDown>
                    <DropDown label="Walls">
                        <RefinementList
                            attribute="walls"
                            limit={500}
                            searchable
                        />
                    </DropDown>
                    <DropDown label="Yard">
                        <RefinementList
                            attribute="yards"
                            limit={500}
                            searchable
                        />
                    </DropDown>
                </div>

                <Configure hitsPerPage={22} />
            </div>

            <div className="py-3 px-3">
                <div className="il-current-refinements-container align-items-start d-flex flex-column flex-md-row">
                    <CurrentRefinements
                        className="w-100"
                    />
                    <Pagination className="w-auto " />
                </div>
                <div className="mb-4">
                    <CustomHits
                        showMap={props.showMap}
                        searchQuery={props.query}
                    />
                </div>
                <div className="mb-4">
                    <Pagination />
                </div>
            </div>
        </Fragment>
    );
}

export default MainContent;
